import { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sidebarSteps as originalSidebarSteps, bottomNavSteps, adminBottomNavSteps, userBottomNavSteps, knowledgeBaseSteps, chooseAiSteps as originalChooseAiSteps } from "./tourSteps";
import { getUserID, getUserRole } from "../../Utility/service";
import { getUserData } from "../../api/userApiFunctions";
import { axiosSecureInstance } from "../../api/axios";

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [showTour, setShowTour] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [isBottomTour, setIsBottomTour] = useState(false);
  const [isKnowledgeBaseTour, setIsKnowledgeBaseTour] = useState(false);
  const [isAiTour, setIsAiTour] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [role, setRole] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isTourConfirmationVisible, setIsTourConfirmationVisible] = useState(false);
  const [isWelcomeModalVisible, setIsWelcomeModalVisible] = useState(false);
  const [isCompletionModalVisible, setIsCompletionModalVisible] = useState(false);
  const [tourCompleted, setTourCompleted] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [chooseAiSteps, setChooseAiSteps] = useState([...originalChooseAiSteps]);
  const resetChooseAiSteps = () => setChooseAiSteps([...originalChooseAiSteps]);

  useEffect(() => {
    const role = getUserRole();
    setUserRole(role);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      const userId = getUserID();
      if (!userId) {
        console.warn("fetchUserData: No user ID found!");
        return;
      }

      const result = await getUserData(userId, setRole);
      if (!result) {
        console.error("fetchUserData: No response received.");
        return;
      }

      const { success, data } = result;
      // if (success && !data.tourCompleted) {
        // setIsWelcomeModalVisible(true);
        // setTimeout(() => setShowTour(true), 500);
        // setTourCompleted(false);
      // } else {
      //   setIsWelcomeModalVisible(false);
      //   setShowTour(false);
      //   setIsKnowledgeBaseTour(false);
      //   setIsAiTour(false);
      //   setIsBottomTour(false);
      //   chooseAiSteps.length = 0;
      //   setTourCompleted(true);
      // }
    };

    fetchUserData();
  }, []);

  const filteredSidebarSteps = originalSidebarSteps.filter((step) =>
    step.adminOnly ? userRole === "admin" || userRole === "superadmin": true
  );

  const sidebarSteps =
    location.pathname === "/public-agent"
      ? originalSidebarSteps.slice(0)
      : originalSidebarSteps;

      const activeSteps =
      isAiTour && chooseAiSteps.length > 0
        ? chooseAiSteps
        : isKnowledgeBaseTour && knowledgeBaseSteps.length > 0
          ? knowledgeBaseSteps
          : isBottomTour
            ? userRole === "admin" && adminBottomNavSteps.length > 0
              ? adminBottomNavSteps
              : userRole === "user" && userBottomNavSteps.length > 0
                ? userBottomNavSteps
                : bottomNavSteps.length > 0
                  ? bottomNavSteps
                  : []
            : sidebarSteps.length > 0
              ? sidebarSteps
              : [];
    

  useEffect(() => {
    if (!isAiTour && !isKnowledgeBaseTour && !isBottomTour) {
      return;
    }

    setShowTour(false);
    setStepIndex(0);

    if (location.pathname === "/knowledge-base") {
      setIsKnowledgeBaseTour(true);
      setIsBottomTour(false);
      setIsAiTour(false);
      setTimeout(() => setShowTour(true), 500);
      return;
    }

    setTimeout(() => {
      const checkElementExists = () => {
        const firstStepTarget = document.querySelector(activeSteps[0]?.target);
        if (firstStepTarget) {
          setTimeout(() => setShowTour(true), 500);
        } else {
          setTimeout(checkElementExists, 500);
        }
      };

      if (activeSteps.length > 0) {
        checkElementExists();
      }
    }, 500);
  }, [location.pathname, isAiTour, isKnowledgeBaseTour, isBottomTour, activeSteps]);

  const handleTourEnd = async (showCompletionModal = true) => {
    try {
      setIsTourConfirmationVisible(false);
      if (showCompletionModal) {
        setIsCompletionModalVisible(true);
      }

      const response = await axiosSecureInstance.post("/api/auth/tour-completed");
      if (response.status === 200) {
        setTourCompleted(true);
        setShowTour(false);
        setIsAiTour(false);
        setIsKnowledgeBaseTour(false);
        setIsBottomTour(false);
        setStepIndex(0);
        chooseAiSteps.length = 0;
      } else {
        console.error("Failed to mark tour as completed");
      }
    } catch (error) {
      console.error("Error updating tour status:", error);
    }
  };

  const startTour = () => {
    setStepIndex(0);
    setShowTour(false);
    setIsWelcomeModalVisible(true);
    setTourCompleted(false);
    setIsAiTour(true);
    setIsKnowledgeBaseTour(false);
    setIsBottomTour(false);
    resetChooseAiSteps();
    setIsDropdownOpen(null);
    navigate("/chat");
    setTimeout(() => setShowTour(true), 500);
  };

  const startBottomNavTour = () => {
    setIsModalVisible(false);
    setIsBottomTour(true);
    setIsKnowledgeBaseTour(false);
    setIsAiTour(false);
    setStepIndex(0);
    setIsDropdownOpen(null)
    setShowTour(false);
    navigate('/chat')
    setTimeout(() => setShowTour(true), 1000);
  };

  const startKnowledgeBaseTour = () => {
    setIsKnowledgeBaseTour(true);
    setIsBottomTour(false);
    setIsAiTour(false);
    setStepIndex(0);
    setShowTour(false);
    setTimeout(() => setShowTour(true), 500);
  };

  const startAiTour = () => {
    setIsAiTour(true);
    setIsKnowledgeBaseTour(false);
    setIsBottomTour(false);
    setStepIndex(0);
    setShowTour(false);
    resetChooseAiSteps();
    setIsDropdownOpen(null);
    setTimeout(() => setShowTour(true), 500);
  };

  const startSidebarTour = () => {
    setIsAiTour(false);
    setIsKnowledgeBaseTour(false);
    setIsBottomTour(false);
    setStepIndex(0);
    setShowTour(false);
    setIsDropdownOpen(null);

    if (!sidebarSteps.length) {
      console.error("sidebarSteps is empty! Check tourSteps.js or route logic.");
      return;
    }

    const checkInitialElement = () => {
      const firstTargetExists = document.querySelector(sidebarSteps[0].target);
      if (firstTargetExists) {
        setShowTour(true);
      } else {
        setTimeout(checkInitialElement, 500);
      }
    };

    setTimeout(checkInitialElement, 500);
  };

  return (
    <TourContext.Provider
      value={{
        showTour,
        setShowTour,
        stepIndex,
        isBottomTour,
        isKnowledgeBaseTour,
        isAiTour,
        isModalVisible,
        setStepIndex,
        sidebarSteps,
        bottomNavSteps,
        knowledgeBaseSteps,
        setIsModalVisible,
        handleTourEnd,
        startBottomNavTour,
        startKnowledgeBaseTour,
        startAiTour,
        setIsBottomTour,
        adminBottomNavSteps,
        userRole,
        chooseAiSteps,
        isDropdownOpen,
        setIsDropdownOpen,
        startTour,
        isWelcomeModalVisible,
        setIsWelcomeModalVisible,
        setIsKnowledgeBaseTour,
        setIsAiTour,
        setIsTourConfirmationVisible,
        isTourConfirmationVisible,
        isCompletionModalVisible,
        setIsCompletionModalVisible,
        tourCompleted,
        setTourCompleted,
        startSidebarTour,
        userBottomNavSteps,
      }}
    >
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);